import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '娱乐分类', href: '/categories' },
  { label: '精品文章', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer no-underline">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-sun-fill text-lg md:text-xl text-background-50"></i>
            </div>
            <span className="text-lg md:text-xl font-semibold text-foreground-900 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
              太阳娱乐
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.href === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.href);
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-all duration-200 whitespace-nowrap"
            >
              登录
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              立即注册
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <nav className="md:hidden pb-4 border-t border-background-200/70 pt-3">
            {navLinks.map((link) => {
              const isActive =
                link.href === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.href);
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="flex gap-3 mt-3 px-4">
              <Link
                to="/about"
                className="flex-1 text-center py-2.5 rounded-lg text-sm font-medium border border-background-300 text-foreground-700 hover:bg-background-100 transition-all duration-200 whitespace-nowrap"
              >
                登录
              </Link>
              <Link
                to="/about"
                className="flex-1 text-center py-2.5 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
              >
                立即注册
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}